export const landing6 = {
  hero: {
    badge: "Bespire Pro — Szervezeteknek",
    title: "Alakítsd a szakmai\nközösségedet marketplace-é.",
    subtitle: "Szakemberközvetítés + képzések + digitális tartalmak — egyetlen, saját márkás felületen.",
    features: [
      "Szakemberek listázása és közvetítése a vásárlóknak",
      "Képzések értékesítése (online/offline)",
      "Digitális tartalmak eladása (videók, anyagok, csomagok)",
      "AI-támogatott működés, minimális adminnal",
    ],
    ctaDemo: "Foglaljunk egy 20 perces áttekintőt",
    ctaModel: "Nézzük meg a működési modellt",
    microcopy: "Nem értékesítési hívás. Bemutatjuk a modellt, megnézzük, hogy passzol-e.",
  },
  painPoints: {
    badge: "Miért éri meg?",
    title: "Amit a Bespire\nazonnal megváltoztat.",
    items: [
      {
        icon: "rocket",
        title: "A weboldalatok értékesít is, nem csak tájékoztat",
        description: "Foglalás, jelentkezés, fizetés — minden egy helyen, a ti felületeteken. Az érdeklődőből azonnal ügyfél lesz.",
      },
      {
        icon: "zap",
        title: "A képzésszervezés percek, nem órák",
        description: "Automatikus visszaigazolás, emlékeztetők, helyszámláló — ti csak a tartalomra fókuszáltok.",
      },
      {
        icon: "search",
        title: "A szakembereiteket megtalálják — nálatok",
        description: "Kereshető, szűrhető profilok a saját felületeteken. Az érdeklődő nálatok foglal, nem a Google-ön.",
      },
      {
        icon: "package",
        title: "A tudásotok termékké válik",
        description: "Képzések, módszertanok, videók — online értékesíthető formában, 0-24-ben, automatikusan.",
      },
    ],
  },
  solution: {
    badge: "A megoldás",
    title: "Sokkal több,\nmint egy weboldal.",
    pillars: [
      {
        icon: "users",
        title: "Szakember marketplace",
        subtitle: "Az érdeklődők a ti felületeteken találják meg a szakembert — nem a Google-ön.",
        features: [
          "Minden szakember egy helyen, kereshető profilokkal",
          "A látogatók szűrnek szakterület, helyszín és elérhetőség alapján",
          "Egy kattintás az érdeklődéstől a foglalásig — nincs felesleges körözés",
          "Teljesen személyre szabható design — a szervezet brandingjére hangolva",
        ],
      },
      {
        icon: "graduationCap",
        title: "Képzések értékesítése",
        subtitle: "Nem csak meghirdetitek — eladjátok. Online jelentkezés, fizetés, visszaigazolás automatikusan.",
        features: [
          "Minden képzés saját értékesítési oldalt kap automatikusan",
          "A jelentkező online fizet és azonnal visszaigazolást kap",
          "Emlékeztetők mennek ki a képzés előtt — manuális munka nélkül",
          "Helyszámláló, kedvezményes árak és kuponkódok beépítve",
        ],
      },
      {
        icon: "fileVideo",
        title: "Digitális tartalmak",
        subtitle: "A videóitok, anyagaitok és módszertanaitok végre eladhatóvá válnak.",
        features: [
          "Videók és letölthető anyagok egy helyen",
          "Csomagok célcsoportonként (pl. szülők, szakemberek)",
          "Egyszeri vagy előfizetéses vásárlás",
          "A vásárolt tartalom a felhasználó profiljában válik elérhetővé",
        ],
      },
      {
        icon: "sparkles",
        title: "AI, ami helyettetek dolgozik",
        subtitle: "Weboldal, naptár, marketing — az AI asszisztens elvégzi az operatív munkát, ti a tartalomra fókuszáltok.",
        features: [
          "Az AI percek alatt felépíti a weboldalatokat — logó, szín, tartalom automatikusan",
          "Képzésekre, konzultációkra 0-24 foglalhatnak, emlékeztetőkkel",
          "Social média posztok, email kampányok — marketing tudás nélkül",
          "Kérdeztek, az AI válaszol és végrehajt — mint egy személyi asszisztens",
        ],
      },
    ],
  },
  benefits: {
    badge: "Előnyök",
    highlightBadge: "Neked ★",
    title: "Miért működik jobban\nmarketplace-ként?",
    columns: [
      {
        icon: "heart",
        title: "Vásárlóknak",
        subtitle: "(szülők, kliensek, érdeklődők)",
        items: [
          "Gyorsabb döntés: átlátható szakemberkínálat",
          "Bizalom: a szervezet márkája + minősítési logika",
          "Könnyű következő lépés: érdeklődés, foglalás, vásárlás egy helyen",
          "Minden szakember egy helyen, ellenőrzött profilokkal",
        ],
      },
      {
        icon: "briefcase",
        title: "Szakembereknek",
        subtitle: "",
        items: [
          "Több megkeresés és jobb minőségű leadek",
          "Profi megjelenés a szervezet ernyője alatt",
          "Kevesebb admin, tisztább folyamatok",
          "Szakértelemre fókuszálhatsz, nem a marketingre",
        ],
      },
      {
        icon: "building",
        title: "A szervezetnek",
        subtitle: "(neked)",
        items: [
          "Új bevételi réteg a képzéseken túl (közvetítés, csomagok, digitális termékek)",
          "Márkakontroll: nem egy külső piactéren, hanem a saját felületeden",
          "Mérhetőség: mi hoz érdeklődőt, mi ad el, hol esik ki a felhasználó",
          "Skálázhatóság: több város, több kategória — ugyanazzal a rendszerrel",
        ],
      },
    ],
  },
  whyWorthIt: {
    badge: "Miért éri meg?",
    title: "6 ok, amiért a Bespire \nmegéri a váltást.",
    items: [
      {
        icon: "zap",
        title: "Napok alatt élesíthető",
        description: "Nem hónapokig tartó fejlesztés — a platform napok alatt élesíthető, szakértői csapatunk segít benne.",
      },
      {
        icon: "bot",
        title: "AI-támogatott működés",
        description: "Tartalom generálás, kommunikáció automatizálás, admin feladatok — az AI asszisztens mindenhol segít.",
      },
      {
        icon: "shield",
        title: "Saját márka alatt",
        description: "Nem egy külső piactéren jelensz meg — a saját márkád, a saját domain-ed, a saját felületed.",
      },
      {
        icon: "globe",
        title: "Többnyelvű rendszer",
        description: "Ha szeretnél terjeszkedni vagy már most is több nyelvet használtok, semmi gond — a rendszer az összes európai nyelvet kezeli.",
      },
      {
        icon: "repeat",
        title: "Upsell & cross-sell automatizálás",
        description: "Képzés → szakember → digitális tartalom (és fordítva): a rendszer automatikusan ajánl és értékesít.",
      },
      {
        icon: "barChart",
        title: "Mérhető ROI",
        description: "Pontosan látod, mi hoz érdeklődőt, mi ad el, hol esik ki a felhasználó — adatvezérelt döntések.",
      },
    ],
  },
  proPackage: {
    title: "Minden, amire egy\noktatóközpontnak szüksége van.",
    description: "Egyedi árazás, teljeskörű platform — az igényeitekre szabva.",
    badge: "Oktatóközpontoknak",
    price: "Egyedi árazás",
    period: "az igényekre szabva",
    cardDescription: "Marketplace, képzésértékesítés és teljes szervezeti működés — egy platformon.",
    features: [
      "Teljes weboldal létrehozása",
      "AI-vezérelt időpontfoglaló rendszer",
      "Digitális termékek értékesítése",
      "Online kurzusok értékesítése",
      "Egyéni vagy csoportos órák értékesítése",
      "Csoportos workshopok szervezése",
      "Bérletek és tagságok kezelése",
      "AI-generált marketing tartalmak",
      "Email marketing automatizálás",
      "Email feliratkozási formok",
      "Saját domain",
      "Többfelhasználós admin felület",
      "Korlátlan munkatárs kezelés",
      "Teljesen egyedi árazás",
      "Dedikált account manager",
      "24/7 elsőbbségi támogatás",
      "AI-asszisztens a napi munkádhoz",
      "Egyedi API integráció",
      "White-label megoldás",
      "Egyedi onboarding és képzés",
      "SLA garancia",
      "Teljes GDPR megfelelés",
      "Priorizált fejlesztési kérések",
    ],
    cta: "Kérj ajánlatot",
  },
  roiCalculator: {
    badge: "ROI kalkulátor",
    title: "Mennyi extra bevétel várható?",
    subtitle: "Modellezzük le 30 másodperc alatt, mit hozhat egy Bespire Pro marketplace a szervezetnek.",
    expertsLabel: "Hány aktív szakember van nálatok?",
    revenueLabel: "Átlagos havi szolgáltatás-bevétel szakemberenként",
    expertsUnit: "szakember",
    revenueUnit: "Ft / hó",
    output: {
      trainings: "képzés értékesítés / hó (becsült)",
      digital: "digitális termék / hó (becsült)",
      bookings: "közvetített foglalás / hó (becsült)",
      total: "extra bevétel havonta",
    },
    disclaimer: "Ez egy iparági átlagra épülő modell. A pontos számokat egy 20 perces konzultáción mutatjuk meg.",
    ctaExact: "Kérek pontos ajánlatot",
  },
  caseStudy: {
    badge: "Esettanulmány",
    title: "Hogyan dolgozik egy szervezet a Bespire Pro-val?",
    subtitle: "Egy tipikus szakmai szervezet 6 hónapos eredménye — anonimizált példa.",
    sample: {
      org: {
        label: "Szervezet",
        value: "Országos Szakmai Egyesület • Egészségügy • 150 szakember",
      },
      challenge: {
        label: "Kihívás",
        value: "Online átállás, 150 szakember koordinálása, egységes ügyfélélmény biztosítása.",
      },
      solution: {
        label: "Megoldás",
        value: "Bespire Pro marketplace + képzéskezelés + digitális tartalom-értékesítés egy felületen.",
      },
      result: {
        label: "Eredmény (6 hónap után)",
        bullets: [
          "+340 képzés értékesítés",
          "+62 új aktív szakember bekapcsolódás",
          "−68% admin idő",
          "+12 200 000 Ft új bevétel",
        ],
      },
    },
    expand: "Részletek megtekintése",
    ctaFull: "Olvasd el a teljes esettanulmányt",
  },
  howItWorks: {
    badge: "Hogyan működik?",
    title: "6 lépésben indulsz.",
    steps: [
      {
        number: "01",
        title: "Jelentkezés",
        description: "Kitöltöd a rövid érdeklődő űrlapot, és felvesszük veled a kapcsolatot 24 órán belül.",
        timeframe: "24 órán belül felvesszük a kapcsolatot",
      },
      {
        number: "02",
        title: "Találkozó",
        description: "Megbeszéljük az igényeidet, céljaidat és elképzeléseidet egy rövid online konzultáción.",
        timeframe: "30 perc online",
      },
      {
        number: "03",
        title: "Árajánlat",
        description: "Személyre szabott ajánlatot küldünk, ami pontosan tartalmazza, mit kapsz és mennyiért.",
        timeframe: "3 munkanap",
      },
      {
        number: "04",
        title: "Elkészítés",
        description: "Felépítjük az oldaladat, beállítjuk a teljes rendszert — neked ezzel nincs dolgod.",
        timeframe: "2–4 hét",
      },
      {
        number: "05",
        title: "Átadás",
        description: "Bemutatjuk a kész rendszert, betanítunk és átadjuk a hozzáféréseket.",
        timeframe: "1 hét betanítás",
      },
      {
        number: "06",
        title: "Indulás",
        description: "Élesítjük az oldalt — te pedig fogadod az első ügyfeleidet!",
        timeframe: "élesítés",
      },
    ],
    totalTime: "Átlagosan 4–6 hét a jelentkezéstől az élesítésig.",
  },
  trustStrip: {
    label: "A Bespire Pro mögött:",
    items: [
      "Magyar fejlesztőcsapat",
      "Teljes GDPR megfelelés",
      "Magyar (EU) szerverek",
      "99,9% SLA rendszergarancia",
    ],
  },
  faq: {
    title: "Gyakori kérdések",
    questions: [
      {
        q: "Kinek való ez a megoldás?",
        a: "Olyan szervezeteknek, akik képzéseket adnak, minősített szakemberekkel dolgoznak, és szeretnének átlátható, bevételt termelő marketplace működést — pl. módszertani szervezetek, szakmai egyesületek, képzési központok.",
      },
      {
        q: "Mi a különbség egy sima weboldalhoz képest?",
        a: "A weboldal tájékoztat. A Bespire Pro üzletet csinál: összehozza a keresletet és a kínálatot, és egyszerűvé teszi a következő lépést (érdeklődés/foglalás/vásárlás).",
      },
      {
        q: "Lehet több célcsoportom? (pl. szülők + szakemberek)",
        a: "Igen — külön üzenetekkel, külön oldalakkal, külön belépési pontokkal. A rendszer támogatja a többszörös célcsoport-kezelést.",
      },
      {
        q: "Mennyibe kerül?",
        a: "A Pro csomag egyedi árazású, a szervezet méretétől és igényeitől függ. Kérj egy 20 perces áttekintést, és személyre szabott ajánlatot adunk.",
      },
      {
        q: "Mennyi idő alatt lehet élesíteni?",
        a: "A struktúra felépítése és a tartalom feltöltése után jellemzően napok alatt élő a rendszer — nem hónapok alatt.",
      },
      {
        q: "Lehet saját domain-en futtatni?",
        a: "Természetesen — a platform teljes egészében a saját márkád és domain-ed alatt fut, a felhasználók nem látnak semmilyen Bespire branding-et.",
      },
      {
        q: "Milyen rendszerünkből tudjuk migrálni az adatainkat?",
        a: "Támogatjuk a leggyakoribb exportformátumokat (CSV, Excel, JSON). A migrációs asszisztens vezet végig az importon, és az induló adatmigráció a Pro csomag része — díjmentes.",
      },
      {
        q: "Lesz dedikált projekt manager?",
        a: "Igen, a Pro csomag része egy nevesített projekt manager az élesítésig, valamint a első 3 hónapos onboarding időszakban. Egy emberrel kommunikáltok, nem ticket-rendszerrel.",
      },
      {
        q: "Hány órás onboarding van a csapatunknak?",
        a: "Szerepkörönként 6–10 óra strukturált képzés (admin, szakember, marketing), rögzített videóanyagokkal, hogy az új belépők is gyorsan beilleszkedjenek.",
      },
      {
        q: "Milyen szerződéses garanciák vannak?",
        a: "99,9% SLA rendszergarancia, GDPR-konform adatfeldolgozói szerződés, kilépési klauzula és bármikor lekérhető teljes adatexport. Minden írásban, nyilvántartottan.",
      },
      {
        q: "Tudunk fizetni átutalással / havi vagy éves számlával?",
        a: "Igen, banki átutalás, magyar ÁFÁ-s számla, választható havi vagy éves elszámolási ciklus. Éves elszámolásnál kedvezményt biztosítunk.",
      },
    ],
  },
  closingCta: {
    title: "Szeretnétek a képzéseken túl is bevételhez jutni ?",
    description: "Mutatok egy mintastruktúrát a ti működésetekre szabva: szakemberek + képzések + digitális tartalmak.",
    ctaDemo: "Kérek egy 20 perces áttekintést",
    ctaFree: "Kérek ajánlott felépítést (ingyen)",
    microcopy: "Az ajánlatkérésre 1 munkanapon belül válaszolunk. A 20 perces konzultáció ingyenes és nem értékesítési hívás.",
  },
  animations: {
    marketplace: {
      searchText: "terapeuta",
      filters: ["Budapest", "Online elérhető"],
      experts: [
        { name: "Dr. Nagy Anna", spec: "Terapeuta", city: "Budapest" },
        { name: "Kiss Péter", spec: "Coach", city: "Online" },
        { name: "Tóth Eszter", spec: "Tanácsadó", city: "Debrecen" },
      ],
      bookButton: "Foglalok",
    },
    course: {
      popular: "Népszerű",
      spots: "hely",
      title: "Alapképzés 2026",
      date: "2026. márc. 15–17.",
      location: "Budapest · 3 napos intenzív",
      price: "89 000 Ft",
      ctaButton: "Jelentkezem →",
      ctaDone: "✓ Jelentkeztem",
      paymentLabel: "Fizetés",
      cardNumber: "•••• •••• •••• 4242",
      totalLabel: "Összeg:",
      payButton: "Fizetek →",
      successTitle: "Sikeres jelentkezés!",
      successSubtitle: "Visszaigazolást küldtünk e-mailben.",
    },
    digitalContent: {
      sectionTitle: "Digitális tartalmak",
      stats: "42 videó · 18.5 óra",
      items: [
        { title: "Módszertani alapok", meta: "12 videó" },
        { title: "Gyakorlati útmutató", meta: "8 videó" },
        { title: "Haladó technikák", meta: "6 videó" },
        { title: "Szülőknek csomag", meta: "16 videó" },
      ],
      price: "4 900 Ft",
      buyButton: "Megvásárolom →",
      successTitle: "Sikeres vásárlás!",
      successSubtitle: "Elérhető a profilodban",
    },
    ai: {
      userMessage: "Jelenítsd meg Farkas Eszter profilját az oldalon!",
      websiteReply: "Farkas Eszter profilja elhelyezve! 🎉",
      bookingsTitle: "3 új foglalás érkezett ma",
      bookings: [
        { name: "Kiss Petra", time: "10:00", status: "✓" },
        { name: "Nagy Tamás", time: "14:30", status: "✓" },
        { name: "Tóth Anna", time: "16:00", status: "⏳" },
      ],
      emailCampaign: "Email kampány elküldve 247 címzettnek",
      socialPost: "Social poszt",
    },
  },
  contactForm: {
    badge: "Kapcsolat",
    title: "Beszéljük meg a lehetőségeket.",
    subtitle: "Töltsd ki az űrlapot, és felvesszük veled a kapcsolatot 24 órán belül.",
    fields: {
      orgName: "Szervezet neve",
      contactPerson: "Kapcsolattartó neve",
      email: "Email cím",
      phone: "Telefonszám",
      website: "Jelenlegi weboldal címe",
      expertCount: "Hány szakemberrel dolgoztok?",
      services: "Milyen szolgáltatásokat szeretnétek?",
      message: "Üzenet",
    },
    placeholders: {
      orgName: "pl. Magyar Coaching Egyesület",
      contactPerson: "pl. Kovács Anna",
      email: "pl. info@szervezet.hu",
      phone: "pl. +36 30 123 4567",
      website: "pl. www.szervezet.hu",
      expertCount: "Válassz...",
      services: "pl. Marketplace, Képzések, Digitális tartalmak",
      message: "Miben segíthetünk? Írd le, mire lenne szükségetek...",
    },
    expertCounts: ["1–100", "100–1000", "1000+"],
    submitButton: "Küldés",
    submitting: "Küldés...",
    successTitle: "Üzenet elküldve!",
    successDescription: "Hamarosan felvesszük veled a kapcsolatot.",
    sla: "Az ajánlatkérésre 1 munkanapon belül válaszolunk. A 20 perces konzultáció ingyenes és nem értékesítési hívás.",
    consultation: {
      title: "Konzultáció foglalás",
      description: "Foglalj egy 30 perces ingyenes konzultációt, ahol megbeszéljük a szervezetedre szabott lehetőségeket.",
      calendarPlaceholder: "Hamarosan elérhető",
      availability: "H–P, 9:00–17:00",
    },
  },
};
